<template>
  <div>
    <nav class="o-adminnavi">
      <ul class="o-adminnavi_toplevel">
        <router-link
          v-for="item in navigation"
          :key="item.route.name"
          tag="li"
          :to="item.route.path"
        >
          <a>{{ $t(`admin.navigation.${item.route.name}.title`) }}</a>
          <ul class="o-adminnavi_sublevel" v-if="item.children">
            <li v-for="child in item.children" :key="child.name">
              <router-link :to="child.path">{{
                $t(
                  `admin.navigation.${item.route.name}.children.${child.name}.title`
                )
              }}</router-link>
            </li>
          </ul>
        </router-link>
      </ul>
    </nav>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { getRouteByName } from '@/assets/js/helper'

export default {
  name: 'BosAdminNavigation',
  components: {},
  data() {
    return {
      navigation: [
        {
          route: getRouteByName('AdminFair'),
          children: [getRouteByName('AdminFairOverview')]
        },
        {
          route: getRouteByName('AdminAdvertising'),
          children: [
            getRouteByName('AdminAdvertisingOverview'),
            getRouteByName('AdminAdvertisingFairWallOverview')
          ]
        },
        {
          route: getRouteByName('AdminCoredata'),
          children: [
            getRouteByName('AdminCoredataOverview'),
            getRouteByName('AdminCoredataTaskTitleOverview'),
            getRouteByName('AdminCoredataFairSeriesOverview'),
            getRouteByName('AdminCoredataBoothServicesOverview'),
            getRouteByName('AdminCoredataBlacklistOverview')
          ]
        }
      ]
    }
  },
  computed: {
    ...mapGetters(['oidcUser', 'menuStatus'])
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/css/variables.scss';

$adminnavi-seperator: 1px solid $brand-gray !default;

$adminnavi-state-outerwidth: 30px !default;
$adminnavi-state-bg: $brand-blue !default;
$adminnavi-state-width: 0.75rem !default;
$adminnavi-state-height: 0.25rem !default;

$adminnavi-link-padding: 12px 15px 12px 0 !default;
$adminnavi-link-font-weight: $font-weight-bold !default;
$adminnavi-link-color: inherit !default;
$adminnavi-link-text-decoration: none !default;
$adminnavi-link-active-color: $adminnavi-state-bg !default;

$adminnavi-sublink-padding: 10px 15px 10px 0 !default;
$adminnavi-sublink-font-size: $adminnavi-link-font-size !default;
$adminnavi-sublink-font-weight: $font-weight-normal !default;
$adminnavi-sublink-color: $adminnavi-link-color !default;
$adminnavi-sublink-active-color: $adminnavi-state-bg !default;

.o-adminnavi {
  ul {
    margin: 0;
    padding: 0;
    list-style: none;

    a {
      display: block;
      text-decoration: $adminnavi-link-text-decoration;
    }

    &.o-adminnavi_toplevel {
      border-top: $adminnavi-seperator;

      > li {
        position: relative;
        padding-left: $adminnavi-state-outerwidth;
        border-bottom: $adminnavi-seperator;

        &:before,
        &:after {
          display: block;
          content: '';
          position: absolute;
          left: 0;
          margin: $adminnavi-link-padding;
          margin-bottom: 0;
          margin-right: 0;
          background-color: $adminnavi-state-bg;
          transform: translateY(0.2em);
        }

        &:before {
          top: floor($adminnavi-link-font-size * 0.5) -
            floor($adminnavi-state-height * 0.5);
          width: $adminnavi-state-width;
          height: $adminnavi-state-height;
        }

        &:after {
          top: floor($adminnavi-link-font-size * 0.5) -
            floor($adminnavi-state-width * 0.5);
          left: floor($adminnavi-state-width * 0.5) -
            floor($adminnavi-state-height * 0.5);
          width: $adminnavi-state-height;
          height: $adminnavi-state-width;
        }

        > a {
          padding: $adminnavi-link-padding;
          font-size: $adminnavi-link-font-size;
          font-weight: $adminnavi-link-font-weight;
          color: $adminnavi-link-color;
        }

        &.router-link-active {
          &:after {
            display: none;
          }

          > a {
            color: $adminnavi-link-active-color;
          }

          .o-adminnavi_sublevel {
            display: block;
          }
        }
      }
    }

    &.o-adminnavi_sublevel {
      display: none;

      > li {
        > a {
          padding: $adminnavi-sublink-padding;
          font-size: $adminnavi-sublink-font-size;
          font-weight: $adminnavi-sublink-font-weight;
          color: $adminnavi-sublink-color;

          &.router-link-active {
            color: $adminnavi-sublink-active-color;
          }
        }
      }
    }
  }
}
</style>
